var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReportsDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_103_4",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_103_4",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAACiklEQVR4nO2dv2tTURiGHxyEUher4lo62Qah0EnB0f/AUVwKdbUgFcGhpYtTXVw6dyjtJjhZEEShiKWgdHFwEKRLh+ImDn5ySaAOkhNokvOee94H3j15n3y5P05yDxhjjDF5mQZWgFfAR+CgBdmlQCaBl8BvIFqWIwrjGnAoUFxYCFwE3guUFhbS5ZFAYWEhXS4AxwKFhYV0uS1QVljIGQ8FygoLOeNZoowT4HkLskwhrLbt/L10LEQMCxHDQsSwEDEsRAwLqUzIZaADLBSYG8AlWiBkureu8kPgCn0Y+QqsA1coUMhj4JdAiTGCnAL3KEjIhkBpMeL86d3/kxfyQKCsGFOaJe5bykImK1lTiX+yryzkvkBBkSHzqkK2BMqJDHmqKuSDQDmRIZuqQo4GeOELBWYv8b52SxWySpk0hVuIEBYihoWIYSFiWIgYFiJGtUKuAk8yJEW1QjqZrrRTWAgW4gnpgycET4gnpA+eEDwhnpA+VDshM5keJpCiWiGqWIgYFiKGhYhhIWJYiBgWIoaFiFGtkBlfGGoJ6XiBykJigA9atV9ZHU+IhcQAHzRPCF4P8VdWHzwheEIkJuR6pqfMpah2QlSxEDEsRAwLEcNCxLAQMSxEjCxCloawM815T3snMj0YQFLIMPDdXjEsRAwLEcNCxLAQMSxEDAsRw0LE8IWhGF6gEsNCxLAQMSxEDAsRw0LEsBAxPicWcvYyPTHuvPmSeF/biPIm098JInNeIEoNO+vEf7KIKHcEyokMu+w0v0mW5a1ASTHGNLvQSTMH/BQoKsaQb8AUBXC3AinfgVkKopmUdwLFxQi2y9tRP26kDvQbvVPig0LzCXgNrAE3cxdqjDGGqvgLzyIpLd4hRXgAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportsDark);
export default __webpack_public_path__ + "static/media/reports-dark.862078329ecf0fdb6b9b212a7451e88c.svg";
export { ForwardRef as ReactComponent };